/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid: 0,          // From Auth
  displayName: "John Doe", // From Auth
  about: "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  photoURL: require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
  status: "online",
  userRole: "admin"
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function (query) {
    return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  // auth state
  user: JSON.parse(localStorage.getItem('user')) || null,
  loginUrl: '/auth/admin/login',
  token: localStorage.getItem('token') || null,
  countUnconfirmedReservationsUrl: 'v1/admin/reservation/unconfirmed/count',
  countUnconfirmedReservation: 0,
  countUpcomingEventsUrl: 'v1/admin/event/upcoming/count',
  countUpcomingEvents: 0,
  countUsersUrl: 'v1/admin/user/count',
  countUsers: 0,
  footerInfoUrl: 'v1/admin/footer',
  footerInfo: [],
  isLoggedIn: false,
  isLoading: false,
  // events state
  eventsUrl: 'v1/admin/event',
  events: [],
  contentUrl: 'v1/admin/content',
  contents: [],
  updateContentUr: 'v1/admin/content/',
  isEventCreated: null,
  search: '',
  searchAll: '',
  // locations state
  locationUrl: 'v1/admin/location',
  uploadUrl: 'v1/admin/image',
  locations: [],
  isLocationCreated: null,
  // reservations
  pendingReservations: [],
  approvedReservations: [],
  reservationsByUserUrl: 'v1/admin/reservation/user/',
  reservationsByUser: [],
  deleteReservationUrl: 'v1/admin/reservation/',
  confirmReservationUrl: 'v1/admin/reservation/',
  allReservationsUrl: 'v1/admin/reservation',
  allReservations: [],
  allPendingReservations: [],
  usersUrl: 'v1/admin/user/all',
  users: [],
  adminsUrl: 'v1/admin/all',
  admins: [],
  createAdminUrl: 'v1/admin/add',
  deleteAdminUrl: 'v1/admin/',
  // errors
  isError: false,
  errorMessage: '',
  // The rest of the app
  AppActiveUser: userDefaults,
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  is_touch_device: is_touch_device(),
  mainLayoutType: themeConfig.mainLayoutType || "vertical",
  navbarSearchAndPinList: navbarSearchAndPinList,
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: "default",
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  starredPages: navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
  theme: themeConfig.theme || "light",
  themePrimaryColor: colors.primary,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,
}

export default state
